<div *ngIf="deviceType === 'mobile'" class="center getStartedContainer">

	<div (swipe)="onSwipeRight($event)" class="slider" data-pos="0">
		<div class="slider__slides">
			<div class="slider__slide">
				<div class="vervendo_logo_container">
					<img src="../../../../assets/img/icon-screen2.svg" />
				</div>
				<div class="welcome_text_s2">
					<img src="../../../../assets/img/text_screen1.svg" />
				</div>
				<div class="screen2_img_container">
					<img src="../../../../assets/img/illustration_quick-steps.svg" />
				</div>
				<div class="screen2_img_container">
					<img src="../../../../assets/img/illustration_request.svg" />
				</div>
				<p class="welcome__body">Let our hosts know your destination, dates, people, but also what you wish to experience.</p>
			</div>
			<div class="slider__slide">
				<div class="vervendo_logo_container">
					<img src="../../../../assets/img/icon-screen2.svg" />
				</div>				
				<img class="screen3_img2" src="../../../../assets/img/text-welcome-screen3.svg"/>
				<div class="screen3_img3_container">
					<img class="screen3_img3" src="../../../../assets/img/illustration_multiple-offers.png" />
				</div>
				<p class="welcome__body">Our hosts will get back to you with their
					best offers to match
					your request.</p>
			</div>
			<!--<div class="slider__slide">
				<div class="vervendo_logo_container">
					<img src="../../../../assets/img/icon-screen2.svg" />
				</div>
				<img class="screen4_img2" src="../../../../assets/img/text_screen3.svg" />
				<div class="screen4_img4_container">
					<img class="screen4_img4" src="../../../../assets/img/illustration_mobile-offers.svg" />

					<div class="screen3_button_container">
						<button (click)="createRequest()">Let's go<p class="has-arrow-right"></p></button>
					</div>
					<p class="welcome__body">And then select the offer that suits you best and book it! With great ease
						at the best price!</p>
				</div>
			</div>-->
		</div>
		<div class="slider__dots" id="slider__dotsAll">
			<p class="slider__indicator"></p>
			<div class="dot-outline">
				<p id="page0" class="slider__dot hidden" data-pos="0"></p>
			</div>
			<p class="line"></p>
			<div class="dot-outline">
				<p id="page1" class="slider__dot hidden" data-pos="1"></p>
			</div>
			<p class="line"></p>
			<div class="dot-outline">
				<p id="page2" class="slider__dot hidden" data-pos="2"></p>
			</div>
		</div>
	</div>

</div>

<div *ngIf="deviceType === 'desktop' || deviceType === 'tablet'">
	<app-home></app-home>
</div>